export default "__VITE_ASSET__Bc$RJWij__"